export const Validator = (valType) => {
    switch (valType.toUpperCase()) {
        case "SIZE":
            return [
                { labelName: "Minimum Value", name: "min", type: "number", defaultValue: "0", size: 6, placeholder: "Minimum Value..." },
                { labelName: "Maximum Value", name: "max", type: "number", defaultValue: null, size: 6, placeholder: "Maximum Value..." },
            ];

        case "NULL": case "NOT_NULL": case "NOT_BLANK": case "NOT_EMPTY":
            return [];

        case "EMAIL":
            return [{ labelName: "Email Regex", name: "regex", type: "text", defaultValue: null, size: 12, placeholder: "Email Regex..." },];

        case "MAX":
            return [
                { labelName: "Maximum", name: "min", type: "number", defaultValue: null, size: 6, placeholder: "Maximum value..." },
                { labelName: "Inclusive Maximum", name: "inclusive", type: "checkbox", defaultValue: true, size: 6, placeholder: "" },
            ];

        case "MIN":
            return [
                { labelName: "Minimum", name: "min", type: "number", defaultValue: null, size: 6, placeholder: "Minimum value..." },
                { labelName: "Inclusive Minimum", name: "inclusive", type: "checkbox", defaultValue: true, size: 6, placeholder: "" },
            ];

        case "DIGIT":
            return [
                { labelName: "Digit Value", name: "integer", type: "number", defaultValue: null, size: 6, placeholder: "Digit value..." },
                { labelName: "Fraction", name: "fraction", type: "number", defaultValue: null, size: 6, placeholder: "Fraction Value..." },
            ];

        case "DECIMAL_MAX":
            return [
                { labelName: "Maximum Value", name: "decimalMax", type: "number", defaultValue: null, size: 6, placeholder: "Decimal Maximum Value..." },
                { labelName: "Inclusive", name: "inclusive", type: "checkbox", defaultValue: true, size: 6, placeholder: "" },
            ];

        case "DECIMAL_MIN":
            return [
                { labelName: "Minimum Value", name: "decimalMin", type: "number", defaultValue: null, size: 6, placeholder: "Decimal Minimum Value..." },
                { labelName: "Inclusive", name: "inclusive", type: "checkbox", defaultValue: true, size: 6, placeholder: "" },
            ];
        default:
            return [];
    }
}